import { writable } from 'svelte/store';
import { authStatusUrl } from '$lib/config/auth';

export type AuthStatus = {
	loggedIn: boolean;
	debugHeaders: Record<string, string>;
};

export const authStatus = writable<AuthStatus | null>(null);
export const authStatusError = writable<string | null>(null);

export async function refreshAuthStatus(fetchFn: typeof fetch = fetch): Promise<void> {
	authStatusError.set(null);

	try {
		const response = await fetchFn(authStatusUrl, {
			credentials: 'include',
			cache: 'no-store'
		});
		if (!response.ok) {
			throw new Error(`Auth status request failed (${response.status})`);
		}
		const data = (await response.json()) as AuthStatus;
		authStatus.set({
			loggedIn: Boolean(data.loggedIn),
			debugHeaders: data.debugHeaders ?? {}
		});
	} catch (error) {
		authStatus.set({ loggedIn: false, debugHeaders: {} });
		authStatusError.set(error instanceof Error ? error.message : 'Failed to fetch auth status');
	}
}
